import { isEmpty } from '@ember/utils';
import Modifier from 'ember-modifier';

interface AssignTextSuccessCriticalClassSignature {
  Args: {
    Positional: [value: number | null, neutralValue?: number];
  };
  Element: HTMLElement;
}

export default class AssignTextSuccessCriticalClassModifier extends Modifier<AssignTextSuccessCriticalClassSignature> {
  modify(
    element: AssignTextSuccessCriticalClassSignature['Element'],
    [
      value,
      neutralValue = 0,
    ]: AssignTextSuccessCriticalClassSignature['Args']['Positional'],
  ): void {
    if (isEmpty(value) || typeof value !== 'number') {
      return;
    }

    if (value > neutralValue) {
      // Remove opposite color class.
      // Necessary for chart tooltips as they are re-rendered on hover, otherwise they end up with multiple classes.
      // Using a destructor doesn't work, because the tooltip element isn't destroyed when hovering out.
      element.classList.remove('text-critical-default');

      element.classList.add('text-success-default');
    } else if (value < neutralValue) {
      // Remove opposite color class.
      // Necessary for chart tooltips as they are re-rendered on hover, otherwise they end up with multiple classes.
      // Using a destructor doesn't work, because the tooltip element isn't destroyed when hovering out.
      element.classList.remove('text-success-default');

      element.classList.add('text-critical-default');
    } else {
      // Remove all color classes if the value is neutral.
      // Necessary for chart tooltips as they are re-rendered on hover, otherwise they end up with multiple classes.
      // Using a destructor doesn't work, because the tooltip element isn't destroyed when hovering out.
      element.classList.remove('text-success-default');
      element.classList.remove('text-critical-default');
    }
  }
}
